import { Link, Button, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { toast } from "react-toastify";
import { EditableInputDisplay } from "../../components/EditableComponents";

const copyLink = async (url) => {
  try {
    await navigator.clipboard.writeText(url);
    toast.success("Link copiato negli appunti");
  } catch {
    toast.error("Impossibile copiare il link");
  }
};

const getColumns = (editingTelevisitId, setParentValue) => {
  return [
    {
      size: 180,
      muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
      enableColumnFilter: true,
      filterFn: "contains",
      accessorFn: (row) => `${row.patient_info}`,
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      header: "Paziente",
    },
    {
      size: 180,
      muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
      enableColumnFilter: true,
      filterFn: "contains",
      accessorFn: (row) => `${row.doctor_info}`,
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      header: "Professionista Sanitario",
    },
    {
      size: 180,
      enableColumnFilter: false,
      header: "Data/ora",
      Cell: ({ cell, row }) => (
        <EditableInputDisplay
          label={null}
          id={"date"}
          setEditMode={editingTelevisitId === row.original.id}
          initialValue={row.original.date}
          inputMode={"datetime"}
          setParentValue={setParentValue}
        />
      ),
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    },
    {
      size: 260,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Stack spacing={0.5} alignItems="flex-start">
          {(row.original.participant_links || []).map((participantLink) =>
            participantLink.can_open ? (
              <Link
                key={participantLink.participant_id}
                target="_blank"
                rel="noopener noreferrer"
                href={participantLink.url}
              >
                Collegati — {participantLink.name}
              </Link>
            ) : (
              <Button
                key={participantLink.participant_id}
                size="small"
                startIcon={<ContentCopyIcon />}
                onClick={() => copyLink(participantLink.url)}
              >
                Copia link — {participantLink.name}
              </Button>
            )
          )}
        </Stack>
      ),
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      header: "Link",
    },
    {
      size: 5,
      accessorKey: "is_done",
      enableColumnFilter: false, // TODO
      muiTableHeadCellFilterTextFieldProps: {
        placeholder: "Da fare/completata",
      },
      accessorFn: (row) => (row.is_active ? "true" : "false"),
      filterVariant: "checkbox",
      Cell: ({ cell }) =>
        cell.getValue() === "true" ? (
          <DoneIcon color="success" />
        ) : (
          <CloseIcon color="error" />
        ),
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      header: "Attivo",
    },
  ];
};

export default getColumns;
